module.exports = __webpack_public_path__ + "static/media/ns_th.d403b099.png";